import { supabase } from '../supabaseClient';

/* Accès aux données « notify-email ». Chaque fonction renvoie la requête Supabase telle quelle
   (à attendre par l'appelant) : aucune logique métier ici. */

export function sendNotificationEmail(subject, text, to) {
  return supabase.functions.invoke('notify-email', {
    body: { to, subject, text },
  });
}
